import { useQuery } from '@tanstack/react-query';
import { getContactById } from '../services/contactsApi';
import type { ContactResponse } from '@troia-v3/types';

/**
 * Hook para buscar dados de um contato específico
 */
export const useContact = (contactId: string | undefined) => {
  return useQuery({
    queryKey: ['contact', contactId],
    queryFn: async (): Promise<ContactResponse | null> => {
      if (!contactId) return null;
      return await getContactById(contactId);
    },
    enabled: !!contactId,
    staleTime: 5 * 60 * 1000, // 5 minutes
  });
};
